import React, { useEffect } from "react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";
import Services from "../components/home/Services";
import AppointmentBanner from "../components/AppointmentBanner";
import WhyChoose from "../components/home/WhyChoose";

const ServicesPage = () => {
  useEffect(() => {
    document.title = "Services – Moggies & Doggies Veterinary Care";
  }, []);
  return (
    <div className="min-h-screen bg-white font-body text-pawelle-body">
      <SiteHeader />
      <main>
        <PageBanner
          title="Services"
          subtitle="Experience Trusted Pet Care at Moggies & Doggies Veterinary Care"
          crumbs={["Services"]}
        />
        <Services />
        <div className="mx-auto max-w-[1290px] px-5 py-4">
          <AppointmentBanner />
        </div>
        <WhyChoose />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;
